export default __webpack_public_path__ + "static/media/aviabue-mb.ffe786e7.png";